/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery } from "redux-saga/effects";
import { getRequest, postRequest, putRequest } from "../../helpers/Api";
import { types } from "../reducers/companies";
import { types as formTypes } from "../reducers/forms";
import { userNotAuthorizedHandler } from "./authentication";

function* storeCompany({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/company/${payload.id}` : "/company",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.company),
    });

    if (res.status === 409) {
      yield put({
        type: formTypes.SET_VALIDATION_ERRORS,
        payload: {
          errors: [
            {
              key: res.response && res.response.field ? res.response.field : "phoneNumber",
              error:
                res.response && res.response.message
                  ? res.response.message
                  : res.message === "Conflict"
                  ? "Phone number is used already"
                  : res.message,
            },
          ],
        },
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      yield put({ type: types.SET_LOADING, payload: { loading: false } });
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({ type: types.FETCH_COMPANY_REQUEST, payload: { page: 1, perPage: 20 } });
    }
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}
/**
 * @param { activeClass, activeFilter, activeGroup } payload
 * Fetch students when filters are changed
 */
function* fetchCompanyRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const { perPage, page } = payload;
  const params = new URLSearchParams();
  params.append("perPage", perPage || "20");
  params.append("page", page || "1");

  const companyResponse = yield call(getRequest, {
    url: `/company?${params.toString()}`,
    authorized: true,
  });

  if (companyResponse.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (companyResponse.status === 200) {
    const companies = companyResponse.result.map((comp) => {
      if (Array.isArray(comp.domains)) {
        comp.domains = comp.domains.join(", ");
      }
      if (Array.isArray(comp.phoneNumber)) {
        comp.phoneNumber = comp.phoneNumber.join(", ");
      }
      if (comp.status) {
        comp.status = "1";
      } else {
        comp.status = "0";
      }
      return comp;
    });

    yield put({ type: types.ADD_COMPANIES, payload: { companies } });
    yield put({
      type: types.SET_COMPANY_TOTAL_ITEMS,
      payload: {
        totalItems: companyResponse.totalItems,
      },
    });
  } else {
    payload.onFailure(companyResponse.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

function* storeCompanyAdmin({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(putRequest, {
      url: `/company/admin/${payload.id}`,
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.user),
    });

    if (res.status === 409) {
      yield put({
        type: formTypes.SET_VALIDATION_ERRORS,
        payload: {
          errors: [
            {
              key: res.response && res.response.field ? res.response.field : "phoneNumber",
              error:
                res.response && res.response.message
                  ? res.response.message
                  : res.message === "Conflict"
                  ? "Phone number is used already"
                  : res.message,
            },
          ],
        },
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      yield put({ type: types.SET_LOADING, payload: { loading: false } });
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({ type: types.FETCH_COMPANY_REQUEST, payload: { page: 1, perPage: 20 } });
    }
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

function* storeSimplitime({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(putRequest, {
      url: `/company/simplitime${payload.id ? `/${payload.id}` : ""}`,
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.simplitime),
    });

    if (res.status === 409) {
      yield put({
        type: formTypes.SET_VALIDATION_ERRORS,
        payload: {
          errors: [
            {
              key: res.response && res.response.field ? res.response.field : "phoneNumber",
              error:
                res.response && res.response.message
                  ? res.response.message
                  : res.message === "Conflict"
                  ? "Phone number is used already"
                  : res.message,
            },
          ],
        },
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      if (payload.id) {
        yield put({
          type: types.FETCH_COMPANY_REQUEST,
          payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
        });
      }
    } else if (res.status === 403) {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Credentials are invalid"
      );
    } else {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Something went wrong"
      );
    }
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}
function* storeUta({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(putRequest, {
      url: `/company/uta${payload.id ? `/${payload.id}` : ""}`,
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.uta),
    });

    if (res.status === 409) {
      yield put({
        type: formTypes.SET_VALIDATION_ERRORS,
        payload: {
          errors: [
            {
              key: res.response && res.response.field ? res.response.field : "phoneNumber",
              error:
                res.response && res.response.message
                  ? res.response.message
                  : res.message === "Conflict"
                  ? "Phone number is used already"
                  : res.message,
            },
          ],
        },
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      if (payload.id) {
        yield put({
          type: types.FETCH_COMPANY_REQUEST,
          payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
        });
      }
    } else if (res.status === 403) {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Credentials are invalid"
      );
    } else {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Something went wrong"
      );
    }
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}
function* storeUltipro({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(putRequest, {
      url: `/company/ultipro${payload.id ? `/${payload.id}` : ""}`,
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.ultipro),
    });

    if (res.status === 409) {
      yield put({
        type: formTypes.SET_VALIDATION_ERRORS,
        payload: {
          errors: [
            {
              key: res.response && res.response.field ? res.response.field : "phoneNumber",
              error:
                res.response && res.response.message
                  ? res.response.message
                  : res.message === "Conflict"
                  ? "Phone number is used already"
                  : res.message,
            },
          ],
        },
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      if (payload.id) {
        yield put({
          type: types.FETCH_COMPANY_REQUEST,
          payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
        });
      }
    } else if (res.status === 403) {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Credentials are invalid"
      );
    } else {
      payload.onFailure(
        res.response && res.response.message ? res.response.message : "Something went wrong"
      );
    }
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

/**
 * @param { activeClass, activeFilter, activeGroup } payload
 * Fetch students when filters are changed
 */
function* fetchSettings({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });

  const companyResponse = yield call(getRequest, {
    url: `/company/settings`,
    authorized: true,
  });

  if (companyResponse.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (companyResponse.status === 200) {
    yield put({ type: types.ADD_SETTINGS, payload: { company: companyResponse } });
    payload.onSuccess();
  } else {
    payload.onFailure(companyResponse.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

export default function* sagas() {
  yield takeEvery(types.ADD_COMPANY, storeCompany);
  yield takeEvery(types.UPDATE_COMPANY, storeCompany);
  yield takeEvery(types.FETCH_COMPANY_REQUEST, fetchCompanyRequest);
  yield takeEvery(types.STORE_COMPANY_ADMIN, storeCompanyAdmin);
  yield takeEvery(types.STORE_ULTIPRO, storeUltipro);
  yield takeEvery(types.STORE_UTA, storeUta);
  yield takeEvery(types.STORE_SIMPLITIME, storeSimplitime);
  yield takeEvery(types.FETCH_SETTINGS, fetchSettings);
}
